import React, { useState } from "react";
import images from "../../images";
import Button from "../../components/common/Button/Button";
import Copyright from "../../layout/Copyright/Copyright";
import stepOnboard from "./../../contanst/stepOnboard.json";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const StepIndicator = ({ activeStep }) => (
  <div className="flex gap-1 items-center self-center">
    {stepOnboard.map((_, index) => (
      <div
        key={index}
        className={`flex shrink-0 self-stretch my-auto rounded-xl h-[5px] ${
          activeStep === index + 1 ? "bg-indigo-600" : "bg-stone-200"
        }`}
        style={{ width: index + 1 === activeStep ? "24px" : "14px" }}
      />
    ))}
  </div>
);

const OnboardingSteps = () => {
  const [activeStep, setActiveStep] = useState(1);
  const { t } = useTranslation();

  const handleNext = () =>
    setActiveStep((prev) => Math.min(prev + 1, stepOnboard.length));
  const handlePrev = () => setActiveStep((prev) => Math.max(prev - 1, 1));

  return (
    <main className="flex flex-col overflow-hidden pt-14 mx-auto w-full bg-yellow-50 max-w-[480px]">
      <Helmet>
        <meta name="theme-color" content="#fefce8" />
      </Helmet>
      <header className="flex justify-center items-center w-full">
        <img src={images.LogoLogin} className="w-[198px]" alt="Logo" />
      </header>

      <section className="flex flex-col self-center mt-16 w-full max-w-[368px]">
        <h1 className="text-2xl font-semibold text-center text-zinc-800">
          {stepOnboard[activeStep - 1]?.title}
        </h1>
        <figure className="flex flex-col justify-center items-center self-center mt-2.5 w-full min-h-[281px]">
          <img
            loading="lazy"
            src={stepOnboard[activeStep - 1]?.image}
            className="object-contain w-full aspect-[1.75]"
            alt="Step illustration"
          />
        </figure>
        <p className="mt-2.5 text-sm text-center text-neutral-500">
          {stepOnboard[activeStep - 1]?.description}
        </p>
      </section>

      {/* Footer */}
      <footer className="flex flex-col justify-between items-center px-8 pt-9 mt-11 w-full bg-white rounded-[30px_30px_0px_0px] shadow-md">
        <div className="flex flex-col justify-center px-5 w-full">
          <StepIndicator activeStep={activeStep} />

          <nav className="flex gap-10 justify-between items-center mt-5 w-full text-lg font-medium">
            <Button
              text={t("base.prev")}
              className="px-5 py-4 rounded-[15px] min-h-[54px] max-w-[102px] bg-white border border-stone-200 text-neutral-500"
              icon={images.PrevIcon}
              onClick={handlePrev}
              disabled={activeStep === 1}
            />
            <Button
              text={t("base.next")}
              className="px-5 py-4 rounded-[15px] min-h-[54px] max-w-[102px] text-white bg-indigo-600"
              iconRight={images.NextIcon}
              onClick={handleNext}
              disabled={activeStep === stepOnboard.length}
            />
          </nav>
        </div>
        <div className="mt-4">
          <Copyright />
        </div>
      </footer>
    </main>
  );
};

export default OnboardingSteps;
